<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <UserView :inputs="fields"/>
  </div>
</template>

<script>
  import UserView from './UserView';
  import fields from './usersEditingFields.js';

  export default {
    name: 'UserCreation',
    components: {
      UserView
    },
    data () {
      return {
        fields: fields
      }
    }
  }
</script>